/**
 * Core
 */
import Vue from 'vue';
import Router from 'vue-router';

/**
 * Views
 */
import Dashboard from './views/Dashboard.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Splashscreen from './views/SplashScreen.vue';
import Users from './views/Users.vue';
import Workers from './views/Workers.vue';

/**
 * Subviews
 */
import NoPermissions from './views/NoPermissions.vue';
import UserNew from './components/users/UserNew.vue';
import UserEdit from './components/users/UserEdit.vue';
import WorkerNew from './components/workers/WorkerNew.vue';
import WorkerEdit from './components/workers/WorkerEdit.vue';

/**
 * Helpers
 */
import SanitizeUtils from './utils/SanitizeUtils';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // eslint-disable-next-line
    { path: '/logowanie', component: Login, name: 'Logowanie', meta: { layout: 'login' } },
    { path: '/wyloguj', component: Logout, name: 'Wyloguj', },
    { path: '/wczytywanie', component: Splashscreen, name: 'Splashscreen' },
    { path: '/', redirect: '/pracownicy' },
    { path: '/kokpit', redirect: Dashboard },
    { path: '/uzytkownicy', component: Users },
    { path: '/uzytkownicy/nowy', component: UserNew },
    { path: '/uzytkownicy/edycja/:id', component: UserEdit },
    { path: '/pracownicy', component: Workers },
    { path: '/pracownicy/nowy', component: WorkerNew },
    { path: '/pracownicy/edycja/:id', component: WorkerEdit },
    { path: '/404', component: Errors },
    { path: '/brak-uprawnien', component: NoPermissions },
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Wyloguj'
  ];
  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    // next();
    // return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  next();
});

export default router;
